import { getOnetrustFooterCtaText, reloadOTPreferenceCenter } from "@/utils/onetrust";

import {
    KINDS as BUTTON_KINDS,
    SIZES as BUTTON_SIZES,
} from "@/components/buttons/buttons.constants";

import { useUserLocation } from "@/context/UserLocationContext";

import { Locale } from "../../types/locale";
import LinkButton from "../buttons/link-button";

interface Props {
    currentLocale: Locale;
}

export const OnetrustSettingsItem = ({ currentLocale }: Props) => {
    const { isUSVisitor } = useUserLocation();
    
    const handleOnetrustCookieConsent = () => {
        reloadOTPreferenceCenter();
    };

    // Don't render anything if not a US visitor
    if (!isUSVisitor) {
        return null;
    }

    return (
        <li
            key="onetrust-settings-link"
            style={{
                cursor: "pointer",
                width: "max-content",
            }}
        >
            <LinkButton
                label={getOnetrustFooterCtaText(currentLocale)}
                kind={BUTTON_KINDS.UNSET}
                size={BUTTON_SIZES.UNSET}
                onTextClick={handleOnetrustCookieConsent}
            />
        </li>
    );
};
